module.exports = __webpack_public_path__ + "static/media/discord.71daca8a.png";